import { style } from '@vanilla-extract/css';

export const tagsElement = style({
  display: 'var(--tags-display)',
  gap: 'var(--tags-gap)',

  '@media': {
    'only screen and (--mobile)': {
      display: 'var(--tags-mobile-display, var(--tags-display))',
      gap: 'var(--tags-mobile-gap, var(--tags-gap))',
    },
  },
});

export const tagsName = style({
  color: 'var(--tags-name-color)',
  fontFamily: 'var(--tags-name-font-family)',
  textAlign: 'var(--alignment)',
  fontWeight: 'var(--tags-name-font-weight, 600)',
});

export const tagsDescription = style({
  color: 'var(--tags-description-color)',
  fontFamily: 'var(--tags-description-font-family)',
  textAlign: 'var(--alignment)',
  fontWeight: 'var(--tags-description-font-weight, 400)',
});
